import { Component, Injector, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { BlockedDayDialogComponent } from './blocked-days-dialog/blocked-day-dialog.component';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { HttpErrorResponse } from '@angular/common/http';


type FilterType = 'all' | 'holiday' | 'blockSchedule';

@Component({
  selector: 'non-working-days',
  templateUrl: './non-working-days.component.html',
  styleUrls: ['./non-working-days.component.scss']
})

export class NonWorkingDaysComponent extends BaseComponent {

  @Input() practitioner_id: string = ''
  public blockDays: any[] = []
  public filteredBlockDays: any[] = []; 

  constructor(private injector: Injector, private practitionerService: PractitionerService) {
    super(injector)
  }

  // Formulário dos filtros
  filters = new FormGroup({
    year: new FormControl<number | 'all'>('all'),
    type: new FormControl<FilterType>('all'),
    search: new FormControl<string>('')
  });

  yearOptions: Array<number | 'all'> = ['all', 2026, 2025];
  typeOptions: Array<{ value: FilterType; label: string }> = [
    { value: 'all', label: 'Todos' },
    { value: 'holiday', label: 'Feriado' },
    { value: 'blockSchedule', label: 'Não trabalhado' }
  ];

  get selectedYear() {
    return this.filters.controls.year.value;
  }
  get selectedType() {
    return this.filters.controls.type.value;
  }
  get searchText() {
    return this.filters.controls.search.value;
  }

  ngOnInit(){
    
    this.getBlockedDays()

    this.filters.valueChanges.subscribe(() => {
      this.applyFilters();
    });
  }

  getWeekDay(date: string){

    const weekday = new Intl.DateTimeFormat("pt-BR", {
      weekday: "long",
      timeZone: "UTC",
    }).format(new Date(date));

    return weekday

  }

  openBlockedDays() {

    const data = {
      title: "Bloquear Dias",
      param: {
       practitioner_id: this.practitioner_id,
       blockDays: this.blockDays ?? []
      },
    };

    this.dialog.openSmallComponentDialog(
      BlockedDayDialogComponent,
      data
    ).subscribe({
      next: () => {
        this.getBlockedDays()
      }
    });
  }

  getBlockedDays(){

    this.practitionerService.listBlockDays(this.practitioner_id)
      .subscribe({
        next: (blockDays: any[]) => {
          this.blockDays = blockDays

           this.applyFilters();
        },
        error: (error: HttpErrorResponse) => {
          this.showErrorMessage = true

          this.showErrorMessage = error.message || error.error.message
        }
      })

  }

  confirmDeleteBlockDay(block_day_id: string){

     this.layout
          .openDialog({
            showButtonCancel: true,
            buttonText: 'Liberar',
            title: 'Deletar Dia Bloqueado',
            content: "Deseja liberar esse dia novamente?",
          })
          .subscribe((retorno: any) => {
            if (retorno) {
              this.deleteBlockDay(block_day_id)
            }


          });
  }

  deleteBlockDay(block_day_id: string){

    this.practitionerService.deleteBlockDays(this.practitioner_id, block_day_id)
      .subscribe({
        next: (blockDays: any[]) => {
          this.blockDays = blockDays
           this.applyFilters();

          this.openSnackBar("Dia bloqueado removido com sucesso", "success")
        },
        error: (error: HttpErrorResponse) => {
          this.showErrorMessage = true

          this.showErrorMessage = error.message || error.error.message
        }
      })


  }

  private applyFilters() {
    const year = this.filters.controls.year.value;
    const type = this.filters.controls.type.value;

    this.filteredBlockDays = (this.blockDays || []).filter((d) => {
      // YEAR
      if (year !== 'all') {
        const y = new Date(d.date).getUTCFullYear();
        if (y !== year) return false;
      }

      // TYPE
      if (type !== 'all') {
        if (d.type !== type) return false;
      }

      return true;
    });
  }



}